import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/outline'

/* This example requires Tailwind CSS v2.0+ */
const faqs = [
  {
    title: 'Health Insurance Basics',
    questions: [
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
    ],
  },
  {
    title: 'Enrollment',
    questions: [
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
    ],
  },
  {
    title: 'Account Management',
    questions: [
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
      {
        question: 'What if my doctor is not in-network with Evry?',
        answer:
          'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.',
      },
    ],
  },
  // More questions...
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const FaqAccordian = () => {
  return (
    <div className="bg-gray-50">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        {faqs.map(faqList => (
          <div
            key={faqList.title}
            className="max-w-3xl mx-auto divide-y-1 divide-green mt-24"
          >
            <h3 className="text-2xl tracking-tight font-bold text-blue sm:text-3xl uppercase">
              {faqList.title}
            </h3>
            <dl className="mt-6 space-y-6 divide-y divide-lightGrey">
              {faqList.questions.map((faq, index) => (
                <Disclosure as="div" key={index} className="pt-6">
                  {({ open }) => (
                    <>
                      <dt className="text-lg">
                        <Disclosure.Button className="text-left w-full flex justify-between items-start text-grey">
                          <span className="text-grey font-[sans-serif] text-xl">
                            {faq.question}
                          </span>
                          <span className="ml-6 h-7 flex items-center">
                            <ChevronDownIcon
                              className={classNames(
                                open ? '-rotate-180' : 'rotate-0',
                                'h-6 w-6 transform'
                              )}
                              aria-hidden="true"
                            />
                          </span>
                        </Disclosure.Button>
                      </dt>
                      <Disclosure.Panel as="dd" className="mt-2 pr-12">
                        <p className="text-base text-grey">{faq.answer}</p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FaqAccordian
